module.exports = __webpack_public_path__ + "img/face73.b56263c2.gif";